var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 126.61 126.61",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f3ba2f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m38.73 53.2 24.59-24.58 24.6 24.6 14.3-14.31-38.9-38.91-38.9 38.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 63.31 14.3-14.31 14.31 14.31-14.31 14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.73 73.41 24.59 24.59 24.6-24.6 14.31 14.29-38.9 38.91-38.91-38.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98 63.31 14.3-14.31 14.31 14.3-14.31 14.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.83 63.3-14.51-14.52-10.73 10.73-1.24 1.23-2.54 2.54 14.51 14.5 14.51-14.47z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceIcon);
export default __webpack_public_path__ + "static/media/binance-icon.1228492c6bdd19c1a66a8a45ead822f3.svg";
export { ForwardRef as ReactComponent };